interface CategoryTagProps {
  label: string;
  tone?: "primary" | "accent" | "secondary";
  className?: string;
}

const toneMap = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function CategoryTag({ label, tone = "primary", className = "" }: CategoryTagProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${toneMap[tone]} ${className}`}
    >
      {label}
    </span>
  );
}